import router from '@/router'
import store from '@/store'
import bus from "./bus.js"
import { refreshAccessToken } from "api/api.js"
import { postRefreshToken } from "api/http.js"
import { getExpires, getRefreshExpires } from '@/utils/auth'

export const minExpTime = 1800 // 判断过期时间，小于 1800 时间刷新令牌
export const getExpiresTime = (type) => {
  // 判断访问令牌或刷新令牌的过期时间
  const expires = (type === 'refresh' ? getRefreshExpires() : getExpires()) || 0
  const nTime = new Date().getTime()
  const nTimeSecond = Math.floor(nTime / 1000)
  const expTime = expires - nTimeSecond
  return expTime
}

const expiresCalculation = () => {
  const expTime = getExpiresTime()
  console.log('剩余时间',expTime)
  return new Promise(async (resolve, reject) => {
    // 客户端时间过期（7天）就退出界面
    // 令牌时间超过到期前30分钟就更新令牌
    if (expTime && expTime > minExpTime) {
      resolve()
    } else if (expTime && expTime > 1) {
      store.dispatch('user/expiresflag', true)
      await refreshAccessToken().then((res) => {
        if (res && res.code === 10000) {
          const cont = res.content;
          store.dispatch('user/setNewTokenInfo', cont)
        }
        resolve(true)
      }).catch(()=>{
        reject()
      })
    } else {
      const refreshRes = await postRefreshToken()
      if (refreshRes) {
        resolve()
      } else {
        store.dispatch('user/expiresflag', true)
        bus.$message.warning('令牌过期，请重新登录！')
        await store.dispatch('user/logout')
        router.push('/login')
        reject()
      }
    }
  })
}

export default expiresCalculation;



// WEBPACK FOOTER //
// ./src/api/expires.js